module.exports = __webpack_public_path__ + "static/media/icons.8e3c7f55.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styling/theme/assets/fonts/icons.eot
// module id = ./src/styling/theme/assets/fonts/icons.eot
// module chunks = 0